import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1E1E1E",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.3",
      d: "m3.333 5 5.09 3.843.002.001c.565.415.848.622 1.157.702.274.071.562.071.835 0 .31-.08.594-.288 1.16-.703 0 0 3.265-2.505 5.09-3.844M2.5 13.166V6.833c0-.934 0-1.4.182-1.757.16-.314.414-.569.728-.728.356-.182.823-.182 1.757-.182h9.666c.934 0 1.4 0 1.757.182.313.16.569.414.729.728.181.356.181.823.181 1.754v6.339c0 .932 0 1.397-.181 1.754-.16.313-.416.568-.73.728-.356.182-.821.182-1.753.182H5.164c-.932 0-1.398 0-1.754-.182a1.667 1.667 0 0 1-.728-.728C2.5 14.566 2.5 14.1 2.5 13.166Z"
    }, null, -1)
  ]))]))
}
export default { render: render }